module.exports = __webpack_public_path__ + "img/suspension_system.b0dbae58.svg";